import { Grid } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import { observer } from "mobx-react";
import React from "react";
import type ChartCardStore from "../ChartCardStore";
import { Module } from "components/Admin/Organizations/types/Module.type";

type SingleModuleControlProps = {
    store: ChartCardStore;
    modules: Array<Module>;
};

const SingleModuleControl = observer(({ store, modules }: SingleModuleControlProps) => {
    const optionsLoading = store.optionsStore.orgModulesLoading;
    return (
        <Grid item xs={3}>
            <AcxSelect
                fullWidth
                defaultValue={
                    store.selectedIds["module"]
                        ? modules.find(
                              (item) => item.id === store.selectedIds.module,
                          )
                        : undefined
                }
                options={modules}
                onChange={(item) => {
                    store.setSelectedId("module", item.id);
                    store.handleSelectionChange();
                }}
                placeholder="Select Module"
                id={`signals-chart-select-module-${store.id}`}
                labelField="displayName"
                valueField="id"
                alternateItemColor={theme.palette.gray.main}
                isLoading={optionsLoading}
                isDisabled={store.isReadOnly}
                disabledAppearance="readOnly"
            />
        </Grid>
    );
});

export default SingleModuleControl;
